import TemplateView from "../../../../TemplateView";
import TextNode from './TextNode'
import {HierarchyLevels} from 'constants'
import messageResource from '../../../../messageResource'
import _ from 'underscore'
import EntirelyAssignmentsBlock from './EntirelyAssignmentsBlock'

export default class AssignmentsList extends TemplateView {
    constructor({
        entirelyAssignedTitle = (currentCount, prevCount) => {},
        entirelyAssignedSubTitle = "",
        createNodesForList = (nodeEntities, searchText, revokeMap) => {},
        revokeMap = {},
        actionOnEmptyList = () => {},
        hierarchyLevel = null,
    }) {
        super();

        this.params = {
            entirelyAssignedTitle,
            entirelyAssignedSubTitle,
            createNodesForList,
            revokeMap,
            actionOnEmptyList,
            hierarchyLevel,
        }

        this.state = {
            searchText: "",
            nodeEntities: [],

            entirelyAssignedCurrentLevel: 0,
            entirelyAssignedPrevLevel: 0,

            title: null,
            assignmentsNodes: [],
            isShowArchived: false,
        }

        this.onAnyStatePropertyChanged(['nodeEntities', 'isShowArchived'], () => {
            this._createNodeList()
        })


        this.onStateChanged(() => {
            const title = this.params.entirelyAssignedTitle(this.state.entirelyAssignedCurrentLevel, this.state.entirelyAssignedPrevLevel)
            if (title) {
                this.entireAssignmentsBlock.setState({
                    title: title,
                    plusSelectedItemsText: this.params.entirelyAssignedSubTitle,
                })
            }

            this.$entireAssignmentsBlockContainer.toggle(!!title)

            this.$notFoundMessage.toggle(!_.isEmpty(this.state.searchText)
                                         && _.isEmpty(title)
                                         && this.state.nodeEntities.length === 0)

            this.$notFoundMessage.text(this._getTaskNotFoundMessage())
        })
    }


    templateHtml() {
        return "<div class='workAssignments_list'>" +
               " <div class='entireAssignmentsBlockContainer'></div>" +
               " <div class='list'></div>" +
               " <div class='notFoundMessage'></div>" +
               "</div>";
    }

    afterRender() {
        this.$entireAssignmentsBlockContainer = this.find(".entireAssignmentsBlockContainer")
        this.entireAssignmentsBlock = new EntirelyAssignmentsBlock().init(this.$entireAssignmentsBlockContainer)
        this.$list = this.find(".list")
        this.$notFoundMessage = this.find('.notFoundMessage')

        this._createNodeList()
    }

    _createNodeList() {
        this.$list.empty();

        if(this.state.nodeEntities.length) {
            const nodes = this.params.createNodesForList(
                this.state.nodeEntities,
                this.state.searchText,
                this.params.revokeMap,
                this.state.isShowArchived
            )

            for (let prop of nodes) {
                const deepestLevel = this.params.hierarchyLevel === prop.type
                new TextNode({
                    id: prop.id,
                    type: prop.type,
                    additionalClass: prop.additionalClass,
                    needRevokeButton: deepestLevel,
                }).init(this.$list).setState(prop)
            }
        }
    }

    _getTaskNotFoundMessage() {

        switch (this.params.hierarchyLevel) {
            case HierarchyLevels.CUSTOMER:
                return messageResource.getMessage('common.customers_not_found_message')
            case HierarchyLevels.PROJECT:
                return messageResource.getMessage('common.projects_not_found_message')
            case HierarchyLevels.TASK:
                return messageResource.getMessage('common.tasks_not_found_message')
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/AssignmentsList.js